module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_oslo_viken_pos.474850d0.png";